<template>
  <div>
    <!-- 上传身份证 -->
    <div class="uploadBox clearfix">
      <div class="uploadBox-state aColor"><img src="../../assets/images/safety.png" alt=""> 本页面上传信息仅用于监管机构及银行审核</div>
      <div style="margin: 40px 0 30px 0;">请上传您的中国第二代居民身份证原件</div>
      <div class="uploadBox-img">
        <div class="uploadBox-img-left" style="position: absolute; width:305px;height:180px;">
          <el-upload class="avatar-uploader" action :show-file-list="false" :on-change="imgBroadcastChange1" :before-upload="beforeAvatarUploadFront">
            <img v-if="imageUrl1" :src="imageUrl1" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <div class="uploadBox-img-right" style="position: absolute; width:305px;height:180px;">
          <el-upload class="avatar-uploader" action :show-file-list="false" :on-change="imgBroadcastChange2" :before-upload="beforeAvatarUploadBack">
            <img v-if="imageUrl2" :src="imageUrl2" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <div class="uploadBox-alert">
        <span>姓名：<i class="aColor">{{userName}}</i></span>
        <span>身份证号码：<i class="aColor">{{userId}}</i></span>
        <span>有效期：<i class="aColor">{{userDate}}</i></span>
      </div>
      <div class="uploadBox-explain">
        <div class="tip margin-t30">
          <img src="../../assets/images/tip.png" alt="">
          目前仅支持中国税收居民线上开户，如您是其他国家（地区）的居民，请拨打客服电话咨询开户事宜
        </div>
        <div class="introduce">
          <el-checkbox v-model="checked" class="checkbox-two"> </el-checkbox>
          <span class="margin-l10 font-blod">开户须知</span>
        </div>
        <ul>
          <li>点击下方按钮，将为您在展恒基金开设基金交易账户；</li>
          <li>您可使用所填身份证或手机号登录展恒基金网站<a href="https://www.myfund.com/" class="aColor" target="_blank">( www. myfund .com )</a>或展恒基金APP;</li>
          <li>请确保以上身份信息为操作者本人信息;</li>
          <li>请确保身份信息填写正确，填写错误将影响您后续的交易操作;</li>
          <li>以上所填信息我们将会为您严密保管，用于在基金公司开设账户;</li>
          <li>请阅读
            <a href="https://trade.myfund.com/personal/#/openAcctAgreementUserSever" target="_blank">《用户服务协议》</a>、
            <a href="https://trade.myfund.com/personal/#/openAcctAgreement" target="_blank"> 《用户权益须知》</a>和
            <a href="https://trade.myfund.com/personal/#/privacyPolicy" target="_blank">《展恒基金隐私政策》</a>
            <!-- <a href="https://trade.myfund.com/personal/#/openAcctAgreementWt" target="_blank">《委托支付协议》;</a> -->
          </li>
          <li>了解并同意后请在左上方框中打勾</li>
        </ul>
      </div>
      <el-button class="margin-t60" type="normal" @click="openTradeAccount" :disabled="tradeAccountText == '开设交易账户中...'">{{tradeAccountText}}</el-button>
    </div>
    <!-- 账户开通成功 -->
    <el-dialog class="dialog-single-one" center :visible.sync="dialogVisable">
      <img src="../../assets/images/2021_dg.png" alt="" width="60">
      <p class="dialog-single-one-p font-blod aColor">恭喜您开户成功</p>
      <p class="dialog-single-one-p aColor" style="font-size:16px;">已赠送您一个月点财通会员</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="back" @click="browse">先浏览看看</el-button>
        <el-button type="normal" @click="next">下一步</el-button>
      </span>
    </el-dialog>
  </div>

</template>


<script>
const Base64 = require("js-base64").Base64;
export default {
  data () {
    return {
      dialogVisable: false,
      imageUrl1: '',
      imageUrl2: '',
      userName: '',
      userId: '',
      userDate: '',
      fileOne: '',
      fileTwo: '',
      frontInfo: '',
      backInfo: '',
      frontImg: '',
      backImg: '',
      sourceDate: '',
      checked: false,
      cardFlag: '',
      message: '',
      tradeAccountText: '开设交易账户'
    }
  },
  mounted () {
    this.message = this.$route.params
  },
  methods: {
    // 正面上传前
    beforeAvatarUploadFront (file) {
      this.$commonJs.getBase64(this.fileOne).then(result => {
        this.frontImg = result
        this.picLoad(result, '')
      });
      return false
    },
    beforeAvatarUploadBack (file) {
      this.$commonJs.getBase64(this.fileTwo).then(result => {
        this.backImg = result
        this.picLoad('', result)
      });
      return false
    },
    // 正面发生改变
    imgBroadcastChange1 (file, fileList) {
      this.fileOne = file.raw
      this.imageUrl1 = URL.createObjectURL(file.raw);
    },
    // 反面发生改变
    imgBroadcastChange2 (file, fileList) {
      this.fileTwo = file.raw
      this.imageUrl2 = URL.createObjectURL(file.raw);
    },
    // 身份证识别
    picLoad (pic1, pic2) {
      let postData = {
        front: pic1,
        back: pic2,
      };
      this.$http.post(this.$apiPath.identifyOcr, postData).then(res => {
        if (res.data.code == '200' && res.data.success) {
          if (pic2 == '' && res.data.data.address) {// 正面
            this.frontInfo = res.data.data
            this.userName = res.data.data.name
            this.userId = res.data.data.identify
            this.form.certificateno = this.userId
            this.form.sex = this.$commonJs.getSex(this.userId)
            this.form.birthday = this.$commonJs.getDateStrHg(res.data.data.birthday)
          } else if (pic1 == '' && res.data.data.valid) {//反面
            this.backInfo = res.data.data
            this.userDate = this.$commonJs.getDateStrHg(res.data.data.valid)
            this.form.vailddate = this.userDate
          } else {
            this.$message.error('请按照提示上传身份证的对应面，且保持图像清晰！')
          }
        }
      }).catch(() => { })
    },
    // 开设交易账户
    async openTradeAccount () {
      if (!this.checked) {
        this.$message.error('请先勾选开户须知！')
        return
      }
      if (this.userName != '' && this.userId != '' && this.userDate != '') {
        await this.getCardStatus()
        if (this.cardFlag == 'w') {//身份证未开户
          this.tradeAccountText = '开设交易账户中...'
          this.saveIdcardInfo()
        } else if (this.cardFlag == 'r') {//身份证已开户
          this.$message.error('该身份证号已开户！')
        }
      } else {
        this.$message.error('请完善信息后再进行下一步操作！')
      }
    },
    // 判断身份证是否开户
    async getCardStatus () {
      await this.$http.post(this.$apiPath.getOpenAccountStatus, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        depositacct: '',
        certificatetype: '0',
        certificateno: this.userId
      }).then(res => {
        const total = res.data
        // console.log(res);
        if (total.code == '200' && total.message == '成功') {
          if (total.data[0].openstat == "already") {//身份证号已开户
            this.cardFlag = 'r'
          } else if (total.data[0].openstat == "freeze") { //身份证号已开户
            this.cardFlag = 'r'
          } else {//身份证号未开户
            this.cardFlag = 'w'
          }
        } else {//身份证号未开户
          this.cardFlag = 'w'
        }
      }).catch(err => { })
    },
    // 保存身份证信息
    saveIdcardInfo () {
      this.$http.post(this.$apiPath.saveIdPic, {
        identify: this.frontInfo.identify,
        phoneNo: this.$commonJs.getCookie('u_phone1'),
        name: this.frontInfo.name,
        address: this.frontInfo.address,
        birthday: this.frontInfo.birthday,
        gender: this.frontInfo.gender,
        nation: this.frontInfo.nation,
        valid: this.backInfo.valid,
        front: this.frontImg,
        back: this.backImg
      }).then(res => {
        if (res.data.code == '200' && res.data.success) {
          // console.log('保存身份证信息', res);
          this.openAcct()// 公募开户
        } else {
          this.$message.error('身份证信息保存失败')
          this.tradeAccountText = '开设交易账户'
        }
      }).catch(err => { })
    },
    // 公募开户
    openAcct () {
      this.$http.post(this.$apiPath.openAccount, {
        bank_branch: '',//分行
        custname: this.userName, //真实姓名
        depositacctname: this.userName, //真实姓名
        certificatetype: '0', //证件类型
        certificateno: this.userId, //证件号码
        familyname: '',// 姓
        firstname: '', // 名
        mobileno: this.message.phone, //登录页传过来的手机号码
        mobiletelno: this.message.phone,//登录页传过来的手机号码
        email: "", //email地址
        tpasswd: this.message.pass,
        lpasswd: this.message.pass,
        minorid: "",
        depositprov: "", //省份
        depositcity: "", //城市
        bankname: "默认传值", //支行名称(默认)
        investorsbirthday: "", //出生日期
        referral: "", //服务代码
        referralmobile: '',
        custmanagerid: "",
        deliverway: "",
        delivertype: "",
        depositacct: '0000000000000000', //银行卡号(默认)
        custfullname: this.userName, //客户全称
        address: '', //通讯地址
        postcode: '', //邮政编码
        vailddate: this.userDate.replace(/-/g, ''),//"20591231", //证件有效期
        channelname: '默认传值', //银行卡类型(默认)
        telno: '',
        officetelno: '',
        minorflag: '',
        fax: '',
        country: '',
        sex: '',
        educationlevel: '',
        vocationcode: '',
        annualincome: '',
        szsecuritiesaccountid: '',
        shsecuritiesaccountid: '',
        referralprovincename: '',
        referralcityname: '',
        ismainback: '',
        ismainpay: '',
        nickname: '',
        hometelno: '',
        transactorcerttype: '',
        transactorcertno: '',
        transactorname: '',
        transactorvalidate: '',
        transactorcertrefer: '',
        transactortel: '',
        signflag: '1',
        channelid: '7102',//(默认)
        paycenterid: "",
        smallflag: "0"
      }).then(res => {
        // console.log('公募开户', res);
        if (res.data.code == "200") {//向金证签约成功
          const custno = res.data.data.custInfo[0].custno
          //私募开户
          this.openAcctSimu(custno);
          // 私募开户正常后此处代码迁至私募开户成功后执行
          this.openwebsite(custno); //crm中添加开户成功标识
          this.sendOpenAcctMsg();
        } else {
          this.$message.error('公募开户失败')
          this.tradeAccountText = '开设交易账户'
        }
      }).catch(err => { })
    },
    // 私募开户
    openAcctSimu (custno) {
      this.$http.post(this.$apiPath.openAccountSimu, {
        bank_branch: '',//分行
        custname: this.userName, //真实姓名
        depositacctname: this.userName, //真实姓名
        certificatetype: '0', //证件类型
        certificateno: this.userId, //证件号码
        familyname: '',// 姓
        firstname: '', // 名
        //mobileno : document.getElementById("mobiletelno").value, //银行绑定手机号
        mobileno: this.message.phone, //传过来的手机号码
        mobiletelno: this.message.phone,//传过来的手机号码
        email: "", //email地址
        tpasswd: this.message.pass,
        lpasswd: this.message.pass,
        minorid: "",
        depositprov: "", //省份
        depositcity: "", //城市
        bankname: "默认传值", //支行名称
        investorsbirthday: "", //出生日期
        referral: "", //服务代码
        referralmobile: '',
        custmanagerid: "",
        deliverway: "",
        delivertype: "",
        depositacct: "0000000000000000", //银行卡号
        custfullname: this.userName, //客户全称
        address: '', //通讯地址
        postcode: '', //邮政编码
        vailddate: this.userDate.replace(/-/g, ''),//"20591231", //证件有效期
        channelname: "默认传值", //银行卡类型
        telno: '',
        officetelno: '',
        minorflag: '',
        fax: '',
        country: '',
        sex: '',
        educationlevel: '',
        vocationcode: '',
        annualincome: '',
        szsecuritiesaccountid: '',
        shsecuritiesaccountid: '',
        referralprovincename: '',
        referralcityname: '',
        ismainback: '',
        ismainpay: '',
        nickname: '',
        hometelno: '',
        transactorcerttype: '',
        transactorcertno: '',
        transactorname: '',
        transactorvalidate: '',
        transactorcertrefer: '',
        transactortel: '',
        signflag: '1',
        channelid: "7102",
        paycenterid: "2000",	//支付渠道    富友0206   块钱0205   私募2000
        smallflag: "0",   //'1'
        //私募新加参数
        transactionaccountid: "",
        custno: custno,
      }).then(res => {
        // console.log('私募开户', res);
        if (res.data.code == "200") {// 私募开户成功
          this.openwebsite(custno); //crm中添加开户成功标识
          this.sendOpenAcctMsg();
        } else {
          this.$message.error('私募开户失败')
          this.tradeAccountText = '开设交易账户'
        }
      }).catch(err => { })
    },
    // 添加开户信息（执行开户成功后的操作）
    openwebsite (custno) {
      this.$http.post(this.$apiPath.openwebsite, {
        mobileno: this.message.phone,//登录手机号
        certificateno: this.userId,
        referral: '',
        email: '',
        custname: this.userName,
        custno: custno,
        bankNo: "0000000000000000", //银行卡号
      }).then(res => {
        // console.log('添加开户信息', res);
        if (res.data.code == "200") {//录入crm成功
          this.dialogVisable = true
          this.tradeAccountText = '开设交易账户'
        } else {// 插入crm失败
          this.$message.error('添加开户信息失败')
          this.tradeAccountText = '开设交易账户'
        }
      }).catch(err => { })
    },
    // 发邮件到客服邮箱，方便客服联系统计
    sendOpenAcctMsg () {
      this.$http.post(this.$apiPath.sendMailNew, {
        title: this.message.phone,
        name: this.userName,
        content: "网站开户成功",
        email: "khfw@myfp.cn"
      }).then(res => {
        // console.log('发邮件', res);
        if (res.data.code == "0000") {
          // 成功
        }

      }).catch(err => { })
    },
    // 先浏览看看
    async browse () {
      await this.dologin()
      this.$router.push('/myAssets')
    },
    // 下一步
    async next () {
      await this.dologin()
      this.$emit('idCard', '2')// 绑银行卡
    },
    // 登录流程相关的数据存储
    async dologin () {
      await this.$http.post(this.$apiPath.userLogin, {
        id: this.message.phone,
        passwd: this.message.pass,
      }).then(res => {
        // console.log(res);
        if (res.data.code == 200) {
          let mainData = res.data.data
          //身份证
          let certificateno = Base64.encode(mainData.custInfo.certificateno);
          let custname = Base64.encode(mainData.custInfo.custname);
          this.setUserInfo(this.message.pass, certificateno, mainData.custInfo.mobileno, mainData.sessionid, mainData.custInfo.custno, custname, mainData.risklevelInfo[0].risklevel)    // 存cookie
          this.$commonJs.setDomainCookie('u_name', mainData.custInfo.custname)
          this.$commonJs.setDomainCookie('u_risk', mainData.risklevelInfo[0].risklevel)
          this.$commonJs.setDomainCookie('u_custno', mainData.custInfo.custno)
          this.$commonJs.setDomainCookie('u_phone', mainData.custInfo.mobileno)
        } else {
          this.$message.error('开户失败')
        }

      }).catch(err => { })
    },
    // 储存表单信息
    setUserInfo (passWord, certificateno, mobileno, sessionid, custno, custname, risk) {
      // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
      // 如果没有勾选，储存的信息为空
      this.$commonJs.setCookie("u_phone1", mobileno, 7);
      this.$commonJs.setCookie("Password", passWord, 7);
      this.$commonJs.setCookie("sessionid", sessionid, 3);
      this.$commonJs.setCookie("u_id", certificateno, 3);
      this.$commonJs.setCookie("u_custno1", custno, 3);
      this.$commonJs.setCookie("u_name1", custname, 3);
      this.$commonJs.setCookie("acticePath", "/myAssets", 3);
      this.$commonJs.setCookie("u_risk", risk, 3);
    },
  }

}
</script>

<style lang="less" scoped>
.uploadBox {
  width: 800px;
  margin: 20px auto;
  text-align: center;
  font-size: 16px;
  &-state {
    line-height: 120px;
    height: 100px;
    border-bottom: 1px solid @colorDE;
  }
  &-alert {
    margin: 40px auto 0;
    width: 662px;
    height: 50px;
    background: @colorF1;
    line-height: 50px;
    text-align: left;
    span {
      margin: 0 25px;
    }
  }
  &-img {
    position: relative;
    width: 100%;
    height: 180px;
    &-left {
      left: 70px;
      background: url(../../assets/images/IDcard1.png) no-repeat;
    }
    &-right {
      right: 70px;
      background: url(../../assets/images/IDcard2.png) no-repeat;
    }
  }
  &-explain {
    padding: 0 68px;
    text-align: left;
    color: @color3;
    img {
      vertical-align: bottom;
      margin-right: 10px;
    }
    .tip {
      font-size: 14px;
    }
    .introduce {
      margin: 30px 0 20px;
    }
    ul {
      font-size: 14px;
      padding-left: 4px;
      li {
        height: 40px;
        line-height: 40px;
        a {
          color: @color;
        }
      }
      li::before {
        content: "";
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: @color9;
        margin: 0 10px 2px 0;
      }
    }
  }
}
</style>

